import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid2';
import Tooltip from '@mui/material/Tooltip';
import { useFormContext, useFormState } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import Text from '../../../elements/text/Text';
import TextInput from '../../../elements/text-input/TextInput';

const CrawlStep3 = () => {
  const { t } = useTranslation();
  const { control } = useFormContext();
  const { errors } = useFormState({ control });

  return (
    <Box sx={{ overflow: 'hidden' }}>
      <section>
        <Box mb={2} sx={{ mb: 2 }}>
          <Text caption sx={{ color: 'gray' }}>
            {t('asteriskRequired', { ns: 'fields' })}
          </Text>
        </Box>
        <Grid container spacing={1}>
          {['includeInCrawl', 'includeInIndex'].map((inputField) => (
            <Grid
              key={inputField}
              size={{
                xs: 12,
                sm: 6,
              }}
            >
              <Tooltip title={t(inputField, { ns: 'descriptions' })}>
                <Box>
                  <TextInput
                    name={inputField}
                    label={`${t(inputField, { ns: 'fields' })} *`}
                    control={control}
                    errors={errors}
                    size={7}
                  />
                </Box>
              </Tooltip>
            </Grid>
          ))}
        </Grid>
        <Grid container spacing={1} style={{ marginTop: '0.5em' }}>
          {[
            'excludeFromCrawl',
            'excludeFromIndex',
            'excludeContentFromIndex',
          ].map((inputField) => (
            <Grid
              key={inputField}
              size={{
                xs: 12,
                sm: 4,
              }}
            >
              <Tooltip title={t(inputField, { ns: 'descriptions' })}>
                <Box>
                  <TextInput
                    name={inputField}
                    label={t(inputField, { ns: 'fields' })}
                    control={control}
                    errors={errors}
                    size={7}
                  />
                </Box>
              </Tooltip>
            </Grid>
          ))}
        </Grid>
      </section>
    </Box>
  );
};

export default CrawlStep3;
